import { CodeMetadataWire, CodetableMetadata } from "app/area/code-mappings/types-store";

export const mapMetadataToStore = (metadataWire: CodeMetadataWire): CodetableMetadata => ({
  ...(!!metadataWire.label && {
    label: metadataWire.label
  }),

  ...(!!metadataWire.formName && {
    formName: metadataWire.formName
  }),

  ...(!!metadataWire.code && {
    codetable: metadataWire.code
  }),

  features: {
    ...(!!metadataWire.disabled && {
      disabled: metadataWire.disabled
    })
  }
});
